import { useEffect, useState } from 'react';
import api from '../api/client';

// Richieste FIPAV in attesa di validazione + tornei forse annullati da confermare (29/10) (solo per chi ha il permesso "fipav"), per il
// contatore in sidebar. Si aggiorna ogni minuto, al ritorno sulla scheda e dopo ogni azione.
export const avvisaFipavCambiata = () => window.dispatchEvent(new Event('fipav-cambiata'));

export default function useFipavDaValidare(attivo = true) {
  const [n, setN] = useState(0);
  useEffect(() => {
    if (!attivo) { setN(0); return; }
    let vivo = true;
    const carica = () => api.get('/fipav/conteggio').then(r => { if (vivo) setN((r.data.da_validare || 0) + (r.data.annullati_da_confermare || 0)); }).catch(() => {});
    carica();
    const t = setInterval(carica, 60000);
    const onFocus = () => { if (document.visibilityState === 'visible') carica(); };
    window.addEventListener('fipav-cambiata', carica);
    document.addEventListener('visibilitychange', onFocus);
    return () => { vivo = false; clearInterval(t); window.removeEventListener('fipav-cambiata', carica); document.removeEventListener('visibilitychange', onFocus); };
  }, [attivo]);
  return n;
}
